import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import EntitiesBlock from "./components/leadgen-entity/EntitiesBlock";
import { useParams } from "react-router-dom";
import { modelTypes } from "../../common/constants/field-constants";
import ObjectBlock from "./components/leadgen-object/ObjectBlock";
import { connect, useDispatch } from "react-redux";
import { selectLeads } from "../leads/selectors";
import { setLeadId } from "../leads/actions";
import { selectLPS } from '../lps-form/selectors';
import type { RootState } from '../../reducers';

const Leadgen = ({ currentLeadId, processing }) => {
  const { model, id } = useParams();
  const dispatch = useDispatch();
  const [leadId, setId] = useState(null);
  const [objectId, setObjectId] = useState(null);

  useEffect(() => {
    if (processing && processing?.result && processing?.result?.lpc && model === ":model") {
      const { lpc } = processing.result;
      if (lpc.length > 0) {
        dispatch(setLeadId(lpc[0].id));
        setId(lpc[0].id)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processing?.result?.lpc, model]);

  useEffect(() => {
    if (id && model && model === "entity") {
      dispatch(setLeadId(id));
    }
    if (id && model && model === "object") {
      dispatch(setLeadId(0));
    }
  }, [dispatch, id, model]);

  useEffect(() => {
    setId(currentLeadId);
  }, [currentLeadId, id]);

  useEffect(() => {
    setObjectId(currentLeadId);
  }, [objectId, id, currentLeadId]);
  return (
    <Box>
      {((model === modelTypes.ENTITY && leadId) || (processing?.result && leadId)) && (
        <EntitiesBlock entityId={leadId} />
      )}
      {model === modelTypes.OBJECT && id && <ObjectBlock objectId={id} />}
    </Box>
  );
};

function mapStateToProps(state: RootState) {
  const { leads, currentLeadId } = selectLeads(state);
  const { processing } = selectLPS(state);
  return { leads, currentLeadId, processing };
}

export default connect(mapStateToProps)(Leadgen);
